import * as TabsPrimitive from '@radix-ui/react-tabs';

export const TabsRoot = TabsPrimitive.Root;
